import { DownloadIcon } from 'lucide-react';

import { Widget } from '@@/Widget';
import { TextTip } from '@@/Tip/TextTip';
import { Button } from '@@/buttons';
import { BEFeatureIndicator } from '@@/BEFeatureIndicator';
import { FormControl } from '@@/form-components/FormControl';

import { FeatureId } from '../../feature-flags/enums';
import { DateTimeRangePicker } from '../components/DateTimeRangePicker';

export function FilterBar({
  value,
  onChange,
  onExport,
}: {
  value: { start: Date | null; end: Date | null };
  onChange: (value: Partial<{ start: Date | null; end: Date | null }>) => void;
  onExport: () => void;
}) {
  return (
    <Widget>
      <Widget.Body>
        <form className="form-horizontal">
          <FormControl label="Date range">
            <div className="max-w-1/2">
              <DateTimeRangePicker
                startDate={value?.start || undefined}
                endDate={value?.end || undefined}
                onStartDateChange={(d) => onChange({ start: d ?? null })}
                onEndDateChange={(d) => onChange({ end: d ?? null })}
              />
            </div>
          </FormControl>

          <TextTip color="blue">
            Portainer user activity logs have a maximum retention of 7 days.
          </TextTip>

          <div className="mt-4">
            <Button
              color="primary"
              icon={DownloadIcon}
              onClick={onExport}
              className="!ml-0"
              data-cy="activity-logs-export-csv-button"
            >
              Export as CSV
            </Button>
            <BEFeatureIndicator featureId={FeatureId.ACTIVITY_AUDIT} />
          </div>
        </form>
      </Widget.Body>
    </Widget>
  );
}
